<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12">
                <v-row no-gutters cols="12" class="my-3 justify-center">
                    <v-col cols="2">
                        <v-btn-primary
                            block
                            height="40px"
                            elevation="0"
                            class="rounded-lg gradient"
                            @click="routeAnalyseEdition()"
                            data-cy="WordingAnalysisTable-add"
                        >
                            Ajouter
                        </v-btn-primary>
                    </v-col>
                    <!-- DO NOT DELETE BTN : REACTIVATE WHEN analyseBankTransactionWordings resolver call lambda other appollo error when take more than 1 minute-->
                    <!-- <v-col cols="2" class="pl-2">
                        <v-btn-primary
                            block
                            height="40px"
                            elevation="0"
                            class="rounded-lg gradient"
                            :disabled="forClient"
                            @click="analyseDialog = true"
                        >
                            Analyser
                        </v-btn-primary>
                    </v-col> -->
                    <v-col cols="8" class="pl-2">
                        <v-text-field
                            v-model="search"
                            label="Recherche"
                            append-inner-icon="$search"
                            clearable
                            @click:clear="search = ''"
                            hide-details
                            density="compact"
                        />
                    </v-col>
                    <!-- <v-col cols="2" class="pl-2" v-if="!forClient">
                        <v-combobox
                            v-model="filterCompany"
                            :items="allAvailableCompanies"
                            label="Société"
                            item-value="value"
                            density="compact"
                            hide-details
                            :item-title="(item) => item.key"
                            v-if="!forClient"
                        >
                        </v-combobox>
                    </v-col> -->
                    <v-col cols="6" class="pl-2 pt-2" v-if="!useCompanyBTWordingPatterns">
                        <v-switch
                            v-model="useOtherRules"
                            :label="'Utiliser les règles de bobbee et des autres cabinets'"
                        />
                    </v-col>
                </v-row>
            </v-col>
            <RuleTable
                :rule="'wordingAnalysis'"
                :items="items"
                :actionFunction="getActions"
                :wordingFunction="getWording"
                :hideDuplication="true"
                :pagination="pagination"
                :firstRequestDone="firstRequestDone"
                :patternCount="patternCount"
                :accountingCompanyId="accountingCompanyId"
                :maxHeight="maxHeightRT"
                @to-route="routeAnalyseEdition($event.id)"
                @delete="
                    patternToDelete = $event;
                    deleteDialog = true;
                "
            ></RuleTable>
        </v-row>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="patternToDelete = undefined"
            @valid="deletePattern"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer cette règle ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDialog"
            title="Analyser"
            @close="analyseDialog = false"
            @valid="analyse()"
            :validLoading="analyseLoading"
            width="800px"
        >
            <h4 class="text-center">
                &#xca;tes-vous sûr(e) de vouloir analyser tous les dossiers ?
            </h4>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import gql from "graphql-tag";
import colors from "vuetify/lib/util/colors";
import moment from "moment-timezone";
import { User } from "../../store/store";
import { getUserDisplayName } from "../../services/userServices";

import { Apollo } from "@/decorators";

import { Component, Vue, Watch, toNative } from "vue-facing-decorator";
import COMPANY_BT_WORDING_PATTERNS from "../../graphql/CompanyBTWordingPattern.gql";
import WORDING_ANALYSIS from "../../graphql/WordingAnalysis.gql";
import RuleTable from "./RuleTable.vue";

@Component({
    components: {
        RuleTable,
    },
})
export class WordingAnalysisTable extends Vue {
    // forClient: boolean = true

    headers: Array<any> = [
        { text: "Nom", value: "name", sortable: false, align: "center" },
        { text: "Description", value: "description", sortable: false, align: "left" },
        { text: "Type", value: "type", sortable: false, align: "left" },
    ];

    selected: any = {
        index: 0,
        id: "",
    };

    firstRequestDone = false;

    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    addAcc = {
        name: "",
        desc: "",
    };

    accountableAccountType = [
        "Internal",
        "Capital",
        "FixedAssets",
        "Stocks",
        "Sales",
        "Purchase",
        "ThirdParty",
        "Financial",
        "VAT",
        "Special",
    ];

    patternCount: number = 0;

    accTypeSearch = "";

    search = "";

    loading: boolean = true;

    fileName: string = "";

    analyseDialog: boolean = false;
    analyseLoading: boolean = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingCompanyId() {
        if (this.useCompanyBTWordingPatterns) {
            if (this.forClient) {
                return this.$store.state.selected_company?.id;
            }
            return this.filterCompanyId;
        } else {
            return this.$store.state.user.company.id;
        }
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get useOtherRules() {
        if (this.$store.state?.user?.company?.profile) {
            return this.$store.state.user.company.profile.useOtherRules;
        }
        return false;
    }

    set useOtherRules(value) {
        if (this.$store.state?.user?.company?.profile) {
            this.$store.state.user.company.profile.useOtherRules = value;
        }
    }

    get forClient() {
        // return !this.$route.fullPath.includes("/admin/");
        return !!this.$store.state.selected_company;
    }

    get maxHeightRT() {
        if (this.useCompanyBTWordingPatterns) {
            return "calc(100vh - 160px)";
        }
        return "calc(100vh - 208px)";
        const innHeight = window.innerHeight;
        const vhHeight = (230 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    @Watch("useOtherRules")
    async onUserOtherRuleChanged() {
        if (this.$store.state?.user?.company?.profile) {
            await this.$apollo.mutate({
                mutation: gql`
                    mutation UpdateProfileCompany($id: ID!, $useOtherRules: Boolean) {
                        updateProfileCompany(
                            where: { id: $id }
                            data: { useOtherRules: $useOtherRules }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    id: this.$store.state.user.company.profile.id,
                    useOtherRules: this.$store.state.user.company.profile.useOtherRules,
                },
            });
        }
    }

    getActions(item) {
        let title = "";
        if (item.rules.thirdPartyAccountableAccount) {
            title += "Compte de tiers : " + item.rules.thirdPartyAccountableAccount.name;
        }
        if (item.thirdPartyCompany) {
            title += title ? " - " : "";
            title += "Compte auxiliaire : " + item.thirdPartyCompany.name;
        }
        if (item.thirdPartyUser) {
            title += title ? " - " : "";
            title += "Compte auxiliaire : " + getUserDisplayName(item.thirdPartyUser);
        }
        if (item.rules.withoutInvoice) {
            title += title ? " - " : "";
            title += "Sans facture";
        }
        if (item.rules.salesInvoiceAuto) {
            title += title ? " - " : "";
            title += "Encaissement";
        }
        if (item.rules.accountableAccount) {
            title += title ? " - " : "";
            title += "Compte : " + item.rules.accountableAccount.name;
        }
        if (item.rules.zTillReceipt) {
            title += title ? " - " : "";
            title += "Z de caisse";
        }
        return title;
    }

    getWording(item) {
        return item.rules?.outputWording ? "Nouveau libellé : " + item.rules.outputWording : "";
    }

    get condition() {
        if (this.isRootProfile && !this.forClient) {
            return [
                { companyScope: { accountingCompanyOwner: { id: this.accountingCompanyId } } },
                {
                    companyScope: {
                        accountingCompanyOwner: {
                            accountingFirms_some: { id: this.accountingCompanyId },
                        },
                    },
                },
                { companyScope: { scopeSharingStatus: "VALIDATE", accountingCompany: null } },
                { companyScope: { scopeSharingStatus: "PENDING_VALIDATION" } },
            ];
        } else {
            return [
                { companyScope: { accountingCompanyOwner: { id: this.accountingCompanyId } } },
                {
                    companyScope: {
                        accountingCompanyOwner: {
                            accountingFirms_some: { id: this.accountingCompanyId },
                        },
                    },
                },
                { companyScope: { scopeSharingStatus: "VALIDATE", accountingCompany: null } },
            ];
        }
    }

    @Watch("search")
    onSearchModified() {
        this.firstRequestDone = false;
        this.items = [];
        this.pagination.page = 1;
    }

    @Watch("accountingCompanyId")
    resetItems() {
        this.items = [];
        this.pagination.page = 1;
    }

    @Apollo({
        query: WORDING_ANALYSIS,
        skip() {
            return this.useCompanyBTWordingPatterns;
        },
        fetchPolicy: "network-only",
        variables() {
            return {
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                search: this.search ? this.search : "",
                condition: this.condition,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data) {
                    this.firstRequestDone = true;

                    this.items1.push(...data.bankTransactionWordingPatterns);
                    this.patternCount =
                        data.bankTransactionWordingPatternsConnection.aggregate.count;
                } else {
                    this.pagination.page = 1;
                    this.patternCount = 0;
                }
            }
        },
    })
    items1: Array<any> = [];

    @Apollo({
        query: COMPANY_BT_WORDING_PATTERNS,
        skip() {
            return !this.useCompanyBTWordingPatterns;
        },
        fetchPolicy: "network-only",
        variables() {
            return {
                companyId: this.accountingCompanyId,
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                search: this.search ? this.search : "",
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                this.firstRequestDone = true;

                this.items2.push(...data.companyBTWordingPatterns);
                this.patternCount = data.companyBTWordingPatternsConnection?.count;
            } else {
                this.pagination.page = 1;
                this.patternCount = 0;
            }
        },
    })
    items2: Array<any> = [];

    filterCompany = null;

    get useCompanyBTWordingPatterns() {
        return this.forClient || this.filterCompanyId;
    }

    get filterCompanyId() {
        return this.filterCompany ? this.filterCompany.value : "";
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                key: company.name,
            });
            companies.sort((a, b) => {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });
        });
        companies.unshift({ value: "", key: "Toutes mes règles" });

        return companies;
    }

    get items() {
        if (this.useCompanyBTWordingPatterns) {
            return this.items2;
        } else {
            return this.items1;
        }
    }
    set items(value) {
        if (this.useCompanyBTWordingPatterns) {
            this.items2 = value;
        } else {
            this.items1 = value;
        }
    }

    routeAnalyseEdition(id?: string) {
        const params: any = {};
        if (id) {
            params.id = id;
        }
        // const query: any = {};
        // if (this.filterCompany) {
        //     query.imposedCompanyId = this.filterCompanyId;
        // }

        let name = this.forClient
            ? "wording-analysis-edition-client-side"
            : "wording-analysis-edition";
        if (!id) {
            name += "-new";
        }
        this.$router.push({
            name,
            params,
            // query,
        });
    }

    //
    // delete pattern
    //

    patternToDelete;
    deleteDialog = false;
    deleteLoading = false;

    async deletePattern() {
        this.deleteLoading = true;
        if (this.patternToDelete) {
            const bTWP = await this.$apollo.mutate({
                mutation: gql`
                    mutation DeleteBankTransactionWordingPattern($id: ID!) {
                        deleteBankTransactionWordingPattern(where: { id: $id }) {
                            id
                            companyScopeId
                        }
                    }
                `,
                variables: {
                    id: this.patternToDelete.id,
                },
            });
            // await this.$apollo.mutate({
            //     mutation: gql`
            //         mutation DeleteCompanyScope($id: ID!) {
            //             deleteCompanyScope(where: { id: $id }) {
            //                 id
            //             }
            //         }
            //     `,
            //     variables: {
            //         id: bTWP.data.deleteBankTransactionWordingPattern.companyScopeId,
            //     },
            // });
            const indexToDelete = this.items.findIndex((e) => e.id === this.patternToDelete.id);
            if (indexToDelete !== -1) {
                this.items.splice(indexToDelete, 1);
            }
            this.patternToDelete = undefined;
            // this.refresh();
        }
        this.deleteDialog = false;
        this.deleteLoading = false;
    }

    // refresh() {
    //     if (this.$apollo.queries && this.$apollo.queries.items1) {
    //         this.$apollo.queries.items1.refetch();
    //     }
    //     if (this.$apollo.queries && this.$apollo.queries.items2) {
    //         this.$apollo.queries.items2.refetch();
    //     } else {
    //         debugger;
    //     }
    // }

    async analyse() {
        this.analyseLoading = true;
        await this.$apollo.mutate({
            mutation: gql`
                mutation ($startDate: DateTime!, $accountingFirmId: ID!) {
                    analyseBankTransactionWordings(
                        data: { accountingFirmId: $accountingFirmId, startDate: $startDate }
                    ) {
                        status
                    }
                }
            `,
            variables: {
                startDate: moment().add(-1, "years").startOf("year"),
                accountingFirmId: this.accountingCompanyId,
            },
        });
        this.analyseLoading = false;
        this.analyseDialog = false;
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }
}

export default toNative(WordingAnalysisTable);
</script>
